import { render, staticRenderFns } from "./BarChartApplication.vue?vue&type=template&id=06d55fcc&scoped=true&"
import script from "./BarChartApplication.vue?vue&type=script&lang=js&"
export * from "./BarChartApplication.vue?vue&type=script&lang=js&"
import style0 from "./BarChartApplication.vue?vue&type=style&index=0&id=06d55fcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d55fcc",
  null
  
)

export default component.exports